'use strict';

export default angular
  .module('maestro.filters.getItem', [])

  .filter('getItem', function($filter) {
    return function(arr, expression, comparator) {
      let items = $filter('filter')(arr, expression, comparator);
      if (items && items.length > 0) {
        return items[0];
      } else {
        return {};
      }
    };
  })

  .name;
